import React, { Suspense } from 'react';
import { useSelector } from 'react-redux';
import './App.css';
import LinearProgress from '@material-ui/core/LinearProgress';
import { HashRouter } from 'react-router-dom';
import Layout from './components/Layout';
import { selectUser } from './features/auth/authSlice';
import Routers from './routers';

function App() {
  const user = useSelector(selectUser);

  return (
    <Suspense fallback={<LinearProgress />}>
      <HashRouter>
        <Layout user={user}>
          <Routers />
        </Layout>
      </HashRouter>
    </Suspense>
  );
}

export default App;
